module.exports = __webpack_public_path__ + "img/storefront-logo.681279a1.png";